import React__default from "react";
import { c as commonjsGlobal, g as getDefaultExportFromCjs } from "./_commonjsHelpers.js";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      var didWarnAboutKeySpread = {};
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          {
            if (hasOwnProperty.call(props, "key")) {
              var componentName = getComponentNameFromType(type);
              var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
              });
              var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const DallmLogo = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "80", height: "79", viewBox: "0 0 80 79", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { opacity: "0.53", d: "M36.1143 67.2259H4.57143C2.05714 67.2259 0 65.2809 0 62.9037V28.1098C0 13.9545 12.2286 2.39258 27.2 2.39258H36.1143C52.1143 2.39258 65.1428 14.7109 65.1428 29.8387V39.7798C65.1428 54.9076 52.1143 67.2259 36.1143 67.2259Z" }), jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_1687_5664)", children: [jsxRuntimeExports.jsx("path", { d: "M49.9613 76.1556H20.7041C16.247 76.1556 12.5898 72.6978 12.5898 68.4837V35.8509C12.5898 22.3439 24.247 11.3223 38.5327 11.3223H49.9613C65.2756 11.3223 77.7327 23.1003 77.7327 37.5798V49.8981C77.7327 64.3775 65.2756 76.1556 49.9613 76.1556Z" }), jsxRuntimeExports.jsx("path", { d: "M49.9613 76.1556H20.7041C16.247 76.1556 12.5898 72.6978 12.5898 68.4837V35.8509C12.5898 22.3439 24.247 11.3223 38.5327 11.3223H49.9613C65.2756 11.3223 77.7327 23.1003 77.7327 37.5798V49.8981C77.7327 64.3775 65.2756 76.1556 49.9613 76.1556Z", fill: "url(#paint0_linear_1687_5664)", fillOpacity: "0.2" })] }), jsxRuntimeExports.jsx("path", { d: "M35.209 39.166L35.209 47.5168", stroke: "white", strokeWidth: "5", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M58.3379 38.4492L52.4893 43.7387L58.3379 49.0283", stroke: "white", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1687_5664", x1: "67.0482", y1: "19.0313", x2: "52.7082", y2: "39.7448", gradientUnits: "userSpaceOnUse", children: [jsxRuntimeExports.jsx("stop", { offset: "0.325", stopColor: "#CAC6FE" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#9C94FF" })] }), jsxRuntimeExports.jsx("clipPath", { id: "clip0_1687_5664", children: jsxRuntimeExports.jsx("rect", { width: "65.1428", height: "64.8333", fill: "white", transform: "translate(12.5898 11.3223)" }) })] })] }));
const NullFileSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "47", height: "43", viewBox: "0 0 47 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("rect", { x: "3.62109", y: "0.320312", width: "36.9208", height: "33.8413", rx: "5", fill: "#FBBC05" }), jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_1687_5668)", children: [jsxRuntimeExports.jsx("g", { filter: "url(#filter0_b_1687_5668)", children: jsxRuntimeExports.jsx("path", { d: "M39.922 42.4485H7.07933C3.33017 42.4485 0.255859 39.3742 0.255859 35.625V11.0305C0.255859 7.28134 3.33017 4.20703 7.07933 4.20703H17.1271C18.4768 4.20703 19.7515 4.58195 20.8762 5.33178L26.65 9.08094C27.7747 9.83077 29.0494 10.2057 30.3991 10.2057H40.0719C43.8211 10.2057 46.8954 13.28 46.8954 17.0292V35.7C46.7455 39.3742 43.6711 42.4485 39.922 42.4485Z", fill: "#FFE379", fillOpacity: "0.7" }) }), jsxRuntimeExports.jsx("path", { d: "M22.3502 16.4622L16.3832 25.3408C16.099 25.6272 16.2884 26.1046 16.7147 26.1046H19.2246V33.3603C19.2246 33.7899 19.6035 34.1718 20.0297 34.1718H25.9968C26.423 34.1718 26.8019 33.7899 26.8019 33.3603V26.0569H29.3118C29.6907 26.0569 29.8801 25.5795 29.6433 25.2931L23.6289 16.4622C23.2974 16.0803 22.6817 16.0803 22.3502 16.4622Z", fill: "#FFF7E1" })] }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { id: "filter0_b_1687_5668", x: "-6.94414", y: "-2.99297", width: "61.0396", height: "52.6422", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "3.6" }), jsxRuntimeExports.jsx("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_1687_5668" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_backgroundBlur_1687_5668", result: "shape" })] }), jsxRuntimeExports.jsx("clipPath", { id: "clip0_1687_5668", children: jsxRuntimeExports.jsx("rect", { width: "46.4896", height: "38.2414", fill: "white", transform: "translate(0.255859 4.20703)" }) })] })] }));
const HasFileSVG = () => jsxRuntimeExports.jsxs("svg", { width: "47", height: "43", viewBox: "0 0 47 43", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("rect", { x: "3.62109", y: "0.566406", width: "36.9208", height: "33.8413", rx: "5", fill: "#FBBC05" }), jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_1687_5676)", children: [jsxRuntimeExports.jsx("path", { d: "M39.922 42.6946H7.07933C3.33017 42.6946 0.255859 39.6203 0.255859 35.8711V11.2766C0.255859 7.52744 3.33017 4.45312 7.07933 4.45312H17.1271C18.4768 4.45312 19.7515 4.82804 20.8762 5.57787L26.65 9.32703C27.7747 10.0769 29.0494 10.4518 30.3991 10.4518H40.0719C43.8211 10.4518 46.8954 13.5261 46.8954 17.2753V35.9461C46.7455 39.6203 43.6711 42.6946 39.922 42.6946Z", fill: "#FFD847" }), jsxRuntimeExports.jsx("path", { d: "M22.3502 16.7083L16.3832 25.5869C16.099 25.8733 16.2884 26.3507 16.7147 26.3507H19.2246V33.6064C19.2246 34.036 19.6035 34.4178 20.0297 34.4178H25.9968C26.423 34.4178 26.8019 34.036 26.8019 33.6064V26.303H29.3118C29.6907 26.303 29.8801 25.8256 29.6433 25.5392L23.6289 16.7083C23.2974 16.3264 22.6817 16.3264 22.3502 16.7083Z", fill: "#FFF7E1" })] }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsx("clipPath", { id: "clip0_1687_5676", children: jsxRuntimeExports.jsx("rect", { width: "46.4896", height: "38.2414", fill: "white", transform: "translate(0.255859 4.45312)" }) }) })] });
const AddSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16ZM8 14H10V10H14V8H10V4H8V8H4V10H8V14Z", fill: "#CCCCCC" }) }));
const SmileSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "22", height: "20", viewBox: "0 0 22 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M16.09 13.6398C14.9 15.0198 13.16 15.8098 11.3 15.8098C9.43995 15.8098 7.69995 15.0198 6.50995 13.6398C5.93995 12.9798 6.96995 12.1598 7.53995 12.8098C8.46995 13.8898 9.83995 14.5098 11.3 14.5098C12.76 14.5098 14.13 13.8898 15.06 12.8098C15.62 12.1598 16.65 12.9798 16.09 13.6398ZM7.95995 6.77977C8.69995 6.77977 9.29995 7.35977 9.29995 8.06977C9.29995 8.77977 8.69995 9.35977 7.95995 9.35977C7.21995 9.35977 6.61995 8.77977 6.61995 8.06977C6.61995 7.35977 7.21995 6.77977 7.95995 6.77977ZM14.64 6.77977C15.38 6.77977 15.98 7.35977 15.98 8.06977C15.98 8.77977 15.38 9.35977 14.64 9.35977C13.9 9.35977 13.3 8.77977 13.3 8.06977C13.3 7.35977 13.9 6.77977 14.64 6.77977ZM11.3 0.00976562C5.57995 0.00976562 0.949951 4.48977 0.949951 10.0098C0.949951 15.5298 5.57995 20.0098 11.3 20.0098C17.02 20.0098 21.65 15.5298 21.65 10.0098C21.65 4.48977 17.02 0.00976562 11.3 0.00976562Z" }) }));
const SendSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "22", height: "18", viewBox: "0 0 22 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M0.5 0V7L15.49 9L0.5 11V18L21.5 9L0.5 0ZM10.01 11.75L2.5 14.97V12.75L10.01 11.75ZM2.51 3.03L10.02 6.25L2.5 5.25V3.03H2.51Z", fill: "black" }) }));
const ReturnSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "8", height: "12", viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M7.70489 1.41L6.29489 0L0.294891 6L6.29489 12L7.70489 10.59L3.12489 6L7.70489 1.41Z", fill: "white" }) }));
const PeopleSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "11", height: "12", viewBox: "0 0 11 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M5.50003 6.81982C3.72003 6.81982 0.170044 7.70982 0.170044 9.48982V11.4898H10.84V9.48982C10.84 7.71982 7.29004 6.81982 5.51004 6.81982H5.50003ZM5.50003 0.819824C4.03003 0.819824 2.83002 2.00982 2.83002 3.48982C2.83002 4.96982 4.02003 6.15982 5.50003 6.15982C6.98003 6.15982 8.17004 4.96982 8.17004 3.48982C8.17004 2.00982 6.98003 0.819824 5.50003 0.819824ZM5.50003 8.08982C7.48003 8.08982 9.57004 9.05982 9.57004 9.48982V10.2198H1.44003V9.48982C1.44003 9.05982 3.53004 8.08982 5.51004 8.08982H5.50003ZM5.50003 2.08982C6.27003 2.08982 6.90002 2.71982 6.90002 3.48982C6.90002 4.25982 6.27003 4.88982 5.50003 4.88982C4.73003 4.88982 4.10004 4.25982 4.10004 3.48982C4.10004 2.71982 4.73003 2.08982 5.50003 2.08982Z", fill: "#CCCCCC" }) }));
const MoreIcon = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "11", height: "4", viewBox: "0 -4 12 12", fill: "#72767e", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M1.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" }) }));
const LinkFileSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_1293_8987)", children: jsxRuntimeExports.jsx("path", { d: "M15.8365 25.6429C15.6305 25.6409 15.4296 25.5785 15.2588 25.4632C15.0881 25.3479 14.955 25.1849 14.8762 24.9946C14.7974 24.8042 14.7763 24.5949 14.8156 24.3926C14.8549 24.1904 14.9529 24.0041 15.0972 23.8572L22.5544 16.3857C23.4253 15.5148 23.9146 14.3335 23.9146 13.1018C23.9146 11.8701 23.4253 10.6888 22.5544 9.81788C21.6834 8.94692 20.5021 8.45763 19.2704 8.45763C18.0387 8.45763 16.8575 8.94692 15.9865 9.81788L9.02222 16.7822C8.43211 17.3727 8.10078 18.1736 8.10112 19.0084C8.10145 19.8433 8.43343 20.6438 9.02401 21.2339C9.61459 21.8241 10.4154 22.1554 11.2503 22.155C12.0851 22.1547 12.8857 21.8227 13.4758 21.2322L20.0151 14.6929C20.3153 14.3945 20.4848 13.9891 20.4861 13.5658C20.4875 13.1425 20.3206 12.736 20.0222 12.4357C19.7239 12.1355 19.3184 11.966 18.8951 11.9647C18.4718 11.9634 18.0653 12.1302 17.7651 12.4286L12.5115 17.6929C12.315 17.8894 12.0484 17.9998 11.7704 17.9998C11.4925 17.9998 11.2259 17.8894 11.0294 17.6929C10.8328 17.4963 10.7224 17.2298 10.7224 16.9518C10.7224 16.6738 10.8328 16.4073 11.0294 16.2107L16.2829 10.9572C16.9801 10.2916 17.9101 9.92538 18.8738 9.93673C19.8376 9.94809 20.7587 10.3362 21.44 11.0179C22.1213 11.6997 22.5087 12.621 22.5194 13.5848C22.5301 14.5486 22.1632 15.4783 21.4972 16.175L14.9579 22.7143C13.9728 23.698 12.6373 24.25 11.2452 24.249C9.8531 24.248 8.51839 23.694 7.53472 22.7089C6.55105 21.7239 5.999 20.3884 6 18.9962C6.00101 17.6041 6.55499 16.2694 7.54008 15.2857L14.5044 8.32145C15.7703 7.05741 17.4865 6.34803 19.2755 6.34937C21.0644 6.35071 22.7796 7.06265 24.0436 8.32859C25.3077 9.59452 26.0171 11.3107 26.0157 13.0997C26.0144 14.8887 25.3024 16.6038 24.0365 17.8679L16.5794 25.3286C16.3821 25.5261 16.1156 25.6389 15.8365 25.6429Z" }) }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsx("clipPath", { id: "clip0_1293_8987", children: jsxRuntimeExports.jsx("rect", { width: "20", height: "20", transform: "translate(6 6)" }) }) })] }));
const TableFileSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { d: "M16.8598 8.41211H10.8484C10.3929 8.41211 9.95602 8.59306 9.63392 8.91517C9.31181 9.23727 9.13086 9.67413 9.13086 10.1297V23.87C9.13086 24.3255 9.31181 24.7624 9.63392 25.0845C9.95602 25.4066 10.3929 25.5876 10.8484 25.5876H21.1537C21.6092 25.5876 22.0461 25.4066 22.3682 25.0845C22.6903 24.7624 22.8712 24.3255 22.8712 23.87V14.4235L16.8598 8.41211Z", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { d: "M16.8594 8.41211V14.4235H22.8708", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }));
const CompareFileSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { d: "M16 7.7998L16 24.2001", strokeWidth: "2", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M13.5593 22.45H10.0521C8.9233 22.45 7.99609 21.5228 7.99609 20.3941V11.6058C7.99609 10.477 8.9233 9.5498 10.0521 9.5498H13.5593", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M18.4387 22.45H21.946C23.0747 22.45 24.002 21.5228 24.002 20.3941V11.6058C24.002 10.477 23.0747 9.5498 21.946 9.5498H18.4387", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round" })] }));
const CloseSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { d: "M1.95117 1.06006L13.2649 12.3738", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M13.2637 1.06006L1.94996 12.3738", stroke: "white", strokeWidth: "2", strokeLinecap: "round" })] }));
const FileAction = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { children: [jsxRuntimeExports.jsx("circle", { cx: "2.10156", cy: "1.99707", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "2.10156", cy: "7.99707", r: "2" }), jsxRuntimeExports.jsx("circle", { cx: "2.10156", cy: "13.9971", r: "2" })] }));
const CheckSVG = ({ isCheck }) => jsxRuntimeExports.jsxs("svg", { width: "23", height: "22", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("circle", { className: `${isCheck ? "check" : ""}`, cx: "11.4004", cy: "11", r: "10.25", strokeWidth: "1.5" }), isCheck && jsxRuntimeExports.jsx("path", { d: "M6.87988 10.8541L10.0881 13.8432L15.92 8.15674", stroke: "white", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] });
const EditSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({ className: "group/edit" }, props, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { className: "fill-foreground group-hover/edit:fill-primary", d: "M3.30027 15.4096C3.28883 15.4621 3.29113 15.5165 3.30694 15.5678C3.32276 15.6192 3.35157 15.6657 3.39069 15.7031C3.42896 15.7415 3.47644 15.7698 3.52876 15.7855C3.58107 15.8011 3.63655 15.8036 3.69009 15.7926L6.03199 15.3325C6.09601 15.3198 6.15478 15.2888 6.2009 15.2433L15.7537 5.85697C15.7846 5.82682 15.8091 5.79095 15.8258 5.75143C15.8426 5.71191 15.8512 5.66953 15.8512 5.62673C15.8512 5.58393 15.8426 5.54155 15.8258 5.50203C15.8091 5.46252 15.7846 5.42665 15.7537 5.39649L13.8801 3.55587C13.8494 3.52555 13.8129 3.50149 13.7728 3.48508C13.7326 3.46866 13.6896 3.46021 13.6461 3.46021C13.6026 3.46021 13.5595 3.46866 13.5194 3.48508C13.4792 3.50149 13.4427 3.52555 13.4121 3.55587L3.859 12.9419C3.81295 12.9873 3.78161 13.045 3.76892 13.1079L3.30027 15.4096ZM3.62319 17.7514C3.31903 17.7514 3.01785 17.6925 2.73688 17.578C2.45591 17.4635 2.20067 17.2957 1.98575 17.0843C1.71551 16.8193 1.51617 16.4927 1.40551 16.1337C1.29485 15.7747 1.2763 15.3944 1.3515 15.0266L1.82015 12.7251C1.90949 12.2841 2.13012 11.8791 2.45406 11.5614L12.0068 2.1754C12.2215 1.96314 12.4769 1.79485 12.7583 1.68028C13.0396 1.56571 13.3413 1.50713 13.6459 1.50794C14.2652 1.50794 14.8475 1.74518 15.2853 2.17507L17.1586 4.01602C17.3746 4.22704 17.5459 4.47807 17.6625 4.75458C17.7791 5.03109 17.8387 5.32759 17.8379 5.62689C17.8387 5.9262 17.7791 6.22269 17.6625 6.4992C17.5459 6.7757 17.3746 7.02674 17.1586 7.23777L7.60618 16.6231C7.28307 16.9417 6.87098 17.1588 6.42214 17.247L4.07991 17.7071C3.92951 17.7365 3.77653 17.7513 3.62319 17.7514Z" }), jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/edit:stroke-primary", d: "M11.9614 16.9751L15.8076 16.9751", strokeWidth: "2", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/edit:stroke-primary", d: "M11.4863 5.41138L14.4863 8.41132", strokeWidth: "2", strokeLinecap: "round" })] }));
const RemoveSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({ className: "group/remove" }, props, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/remove:stroke-primary", d: "M3.25 5.76501H4.75H16.75", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/remove:stroke-primary", d: "M15.25 6.58689V15.788C15.25 16.1718 15.092 16.5398 14.8107 16.8112C14.5294 17.0825 14.1478 17.235 13.75 17.235H6.25C5.85218 17.235 5.47064 17.0825 5.18934 16.8112C4.90804 16.5398 4.75 16.1718 4.75 15.788V6.58689M7 5.65901V4.21201C7 3.82824 7.15804 3.46019 7.43934 3.18883C7.72064 2.91747 8.10218 2.76501 8.5 2.76501H11.5C11.8978 2.76501 12.2794 2.91747 12.5607 3.18883C12.842 3.46019 13 3.82824 13 4.21201V5.65901", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/remove:stroke-primary", d: "M8.5 9.30457V13.1946", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { className: "stroke-foreground group-hover/remove:stroke-primary", d: "M11.5 9.30457V13.1946", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" })] }));
const ChatSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsxs("g", { opacity: "0.56", children: [jsxRuntimeExports.jsx("g", { filter: "url(#filter0_f_136_293)", children: jsxRuntimeExports.jsx("path", { d: "M20.9365 21.0638H16.753L13.4899 23.6575C13.1553 23.9922 12.5696 23.7412 12.4859 23.2392L12.3186 21.0638H11.0635C9.13916 21.0638 7.63312 19.5577 7.63312 17.6333V11.1072C7.63312 9.1828 9.13916 7.67676 11.0635 7.67676H20.9365C22.8608 7.67676 24.3669 9.1828 24.3669 11.1072V17.6333C24.3669 19.5577 22.8608 21.0638 20.9365 21.0638Z", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinejoin: "round" }) }), jsxRuntimeExports.jsx("g", { filter: "url(#filter1_f_136_293)", children: jsxRuntimeExports.jsx("path", { d: "M11.8166 12.6968H20.1834", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }) }), jsxRuntimeExports.jsx("g", { filter: "url(#filter2_f_136_293)", children: jsxRuntimeExports.jsx("path", { d: "M11.8166 16.0435H16", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }) })] }), jsxRuntimeExports.jsx("path", { d: "M20.9365 21.0638H16.753L13.4899 23.6575C13.1553 23.9922 12.5696 23.7412 12.4859 23.2392L12.3186 21.0638H11.0635C9.13916 21.0638 7.63312 19.5577 7.63312 17.6333V11.1072C7.63312 9.1828 9.13916 7.67676 11.0635 7.67676H20.9365C22.8608 7.67676 24.3669 9.1828 24.3669 11.1072V17.6333C24.3669 19.5577 22.8608 21.0638 20.9365 21.0638Z", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { d: "M11.8166 12.6968H20.1834", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { d: "M11.8166 16.0435H16", stroke: "white", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsxs("defs", { children: [jsxRuntimeExports.jsxs("filter", { id: "filter0_f_136_293", x: "0.0331178", y: "0.0767579", width: "31.9338", height: "31.3323", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3.3", result: "effect1_foregroundBlur_136_293" })] }), jsxRuntimeExports.jsxs("filter", { id: "filter1_f_136_293", x: "4.21656", y: "5.09678", width: "23.5669", height: "15.2", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3.3", result: "effect1_foregroundBlur_136_293" })] }), jsxRuntimeExports.jsxs("filter", { id: "filter2_f_136_293", x: "4.21656", y: "8.44346", width: "19.3834", height: "15.2", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "3.3", result: "effect1_foregroundBlur_136_293" })] })] })] }));
const DownloadSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "41", height: "40", viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("rect", { x: "1", y: "0.5", width: "39", height: "39", rx: "19.5", fill: "#1F2022" }), jsxRuntimeExports.jsx("rect", { x: "1", y: "0.5", width: "39", height: "39", rx: "19.5", stroke: "url(#paint0_linear_1099_1549)" }), jsxRuntimeExports.jsx("path", { d: "M20.3828 13.005L20.3828 22.7279", strokeWidth: "1.6", strokeLinecap: "round" }), jsxRuntimeExports.jsx("path", { d: "M20.2408 22.7287L16.6875 19.176", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { d: "M20.5254 22.7288L24.0781 19.1755", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), jsxRuntimeExports.jsx("path", { d: "M24.5059 26.7876H16.4955", strokeWidth: "1.6", strokeLinecap: "round" }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1099_1549", x1: "0.5", y1: "20", x2: "40.5", y2: "20", gradientUnits: "userSpaceOnUse", children: [jsxRuntimeExports.jsx("stop", { stopColor: "white", stopOpacity: "0.1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })] }) })] }));
const CopySVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { width: "41", height: "40", viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("rect", { x: "1", y: "0.5", width: "39", height: "39", rx: "19.5" }), jsxRuntimeExports.jsx("rect", { x: "1", y: "0.5", width: "39", height: "39", rx: "19.5", stroke: "url(#paint0_linear_1044_1025)" }), jsxRuntimeExports.jsx("rect", { x: "13.9279", y: "16.6597", width: "9.74765", height: "9.74765", rx: "2.2", strokeWidth: "1.6", className: "icon-react" }), jsxRuntimeExports.jsx("rect", { x: "17.3254", y: "13.5928", width: "9.74765", height: "9.74765", rx: "2.2", strokeWidth: "1.6", className: "icon-react" }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1044_1025", x1: "0.5", y1: "20", x2: "40.5", y2: "20", gradientUnits: "userSpaceOnUse", children: [jsxRuntimeExports.jsx("stop", { stopColor: "white", stopOpacity: "0.1" }), jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })] }) })] }));
const HookSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "11", height: "8", viewBox: "0 0 11 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M0.879883 3.85415L4.0881 6.84323L9.92004 1.15674", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
const EditAvatarSVG = (props) => jsxRuntimeExports.jsxs("svg", Object.assign({}, props, { children: [jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_b_758_3312)", children: [jsxRuntimeExports.jsx("rect", { x: "0.733398", y: "0.920898", width: "32", height: "32", rx: "16", fill: "white", fillOpacity: "0.7" }), jsxRuntimeExports.jsx("rect", { x: "8.8916", y: "9.57642", width: "16", height: "14.689", rx: "4", fill: "#1F2022" }), jsxRuntimeExports.jsx("circle", { cx: "16.733", cy: "16.9209", r: "2.53284", stroke: "white", strokeWidth: "1.5" })] }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("filter", { id: "filter0_b_758_3312", x: "-5.2666", y: "-5.0791", width: "44", height: "44", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "3" }), jsxRuntimeExports.jsx("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_758_3312" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_backgroundBlur_758_3312", result: "shape" })] }) })] }));
const SearchSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M13.1291 11.8792H12.4707L12.2374 11.6542C13.0541 10.7042 13.5457 9.47083 13.5457 8.12916C13.5457 5.13749 11.1207 2.71249 8.12907 2.71249C5.1374 2.71249 2.7124 5.13749 2.7124 8.12916C2.7124 11.1208 5.1374 13.5458 8.12907 13.5458C9.47074 13.5458 10.7041 13.0542 11.6541 12.2375L11.8791 12.4708V13.1292L16.0457 17.2875L17.2874 16.0458L13.1291 11.8792ZM8.12907 11.8792C6.05407 11.8792 4.37907 10.2042 4.37907 8.12916C4.37907 6.05416 6.05407 4.37916 8.12907 4.37916C10.2041 4.37916 11.8791 6.05416 11.8791 8.12916C11.8791 10.2042 10.2041 11.8792 8.12907 11.8792Z" }) }));
const ClearWordSVG = (props) => jsxRuntimeExports.jsx("svg", Object.assign({}, props, { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntimeExports.jsx("path", { d: "M8.72699 4.33325L7 6.05995L5.27301 4.33325L4.33301 5.27325L6.06 6.99995L4.33301 8.72655L5.27301 9.66656L7 7.93996L8.72699 9.66656L9.66699 8.72655L7.94 6.99995L9.66699 5.27325L8.72699 4.33325ZM7 0.333252C3.313 0.333252 0.333008 3.31325 0.333008 6.99995C0.333008 10.6866 3.313 13.6666 7 13.6666C10.687 13.6666 13.667 10.6866 13.667 6.99995C13.667 3.31325 10.687 0.333252 7 0.333252ZM7 12.3333C4.06 12.3333 1.66699 9.93995 1.66699 6.99995C1.66699 4.05995 4.06 1.66656 7 1.66656C9.94 1.66656 12.333 4.05995 12.333 6.99995C12.333 9.93995 9.94 12.3333 7 12.3333Z", fill: "#A6A9B8" }) }));
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }(commonjsGlobal, function() {
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t2) {
      var e2 = ["th", "st", "nd", "rd"], n2 = t2 % 100;
      return "[" + t2 + (e2[(n2 - 20) % 10] || e2[n2] || e2[0]) + "]";
    } }, m = function(t2, e2, n2) {
      var r2 = String(t2);
      return !r2 || r2.length >= e2 ? t2 : "" + Array(e2 + 1 - r2.length).join(n2) + t2;
    }, v = { s: m, z: function(t2) {
      var e2 = -t2.utcOffset(), n2 = Math.abs(e2), r2 = Math.floor(n2 / 60), i2 = n2 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i2, 2, "0");
    }, m: function t2(e2, n2) {
      if (e2.date() < n2.date()) return -t2(n2, e2);
      var r2 = 12 * (n2.year() - e2.year()) + (n2.month() - e2.month()), i2 = e2.clone().add(r2, c), s2 = n2 - i2 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
      return +(-(r2 + (n2 - i2) / (s2 ? i2 - u2 : u2 - i2)) || 0);
    }, a: function(t2) {
      return t2 < 0 ? Math.ceil(t2) || 0 : Math.floor(t2);
    }, p: function(t2) {
      return { M: c, y: h, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: f }[t2] || String(t2 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t2) {
      return void 0 === t2;
    } }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t2) {
      return t2 instanceof _ || !(!t2 || !t2[p]);
    }, w = function t2(e2, n2, r2) {
      var i2;
      if (!e2) return g;
      if ("string" == typeof e2) {
        var s2 = e2.toLowerCase();
        D[s2] && (i2 = s2), n2 && (D[s2] = n2, i2 = s2);
        var u2 = e2.split("-");
        if (!i2 && u2.length > 1) return t2(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i2 = a2;
      }
      return !r2 && i2 && (g = i2), i2 || !r2 && g;
    }, O = function(t2, e2) {
      if (S(t2)) return t2.clone();
      var n2 = "object" == typeof e2 ? e2 : {};
      return n2.date = t2, n2.args = arguments, new _(n2);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t2, e2) {
      return O(t2, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t2) {
        this.$L = w(t2.locale, null, true), this.parse(t2), this.$x = this.$x || t2.x || {}, this[p] = true;
      }
      var m2 = M2.prototype;
      return m2.parse = function(t2) {
        this.$d = function(t3) {
          var e2 = t3.date, n2 = t3.utc;
          if (null === e2) return /* @__PURE__ */ new Date(NaN);
          if (b.u(e2)) return /* @__PURE__ */ new Date();
          if (e2 instanceof Date) return new Date(e2);
          if ("string" == typeof e2 && !/Z$/i.test(e2)) {
            var r2 = e2.match($);
            if (r2) {
              var i2 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n2 ? new Date(Date.UTC(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i2, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t2), this.init();
      }, m2.init = function() {
        var t2 = this.$d;
        this.$y = t2.getFullYear(), this.$M = t2.getMonth(), this.$D = t2.getDate(), this.$W = t2.getDay(), this.$H = t2.getHours(), this.$m = t2.getMinutes(), this.$s = t2.getSeconds(), this.$ms = t2.getMilliseconds();
      }, m2.$utils = function() {
        return b;
      }, m2.isValid = function() {
        return !(this.$d.toString() === l);
      }, m2.isSame = function(t2, e2) {
        var n2 = O(t2);
        return this.startOf(e2) <= n2 && n2 <= this.endOf(e2);
      }, m2.isAfter = function(t2, e2) {
        return O(t2) < this.startOf(e2);
      }, m2.isBefore = function(t2, e2) {
        return this.endOf(e2) < O(t2);
      }, m2.$g = function(t2, e2, n2) {
        return b.u(t2) ? this[e2] : this.set(n2, t2);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t2, e2) {
        var n2 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t2), l2 = function(t3, e3) {
          var i2 = b.w(n2.$u ? Date.UTC(n2.$y, e3, t3) : new Date(n2.$y, e3, t3), n2);
          return r2 ? i2 : i2.endOf(a);
        }, $2 = function(t3, e3) {
          return b.w(n2.toDate()[t3].apply(n2.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n2);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
        switch (f2) {
          case h:
            return r2 ? l2(1, 0) : l2(31, 11);
          case c:
            return r2 ? l2(1, M3) : l2(0, M3 + 1);
          case o:
            var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
            return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d:
            return $2(v2 + "Hours", 0);
          case u:
            return $2(v2 + "Minutes", 1);
          case s:
            return $2(v2 + "Seconds", 2);
          case i:
            return $2(v2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t2) {
        return this.startOf(t2, false);
      }, m2.$set = function(t2, e2) {
        var n2, o2 = b.p(t2), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n2 = {}, n2[a] = f2 + "Date", n2[d] = f2 + "Date", n2[c] = f2 + "Month", n2[h] = f2 + "FullYear", n2[u] = f2 + "Hours", n2[s] = f2 + "Minutes", n2[i] = f2 + "Seconds", n2[r] = f2 + "Milliseconds", n2)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === c || o2 === h) {
          var y2 = this.clone().set(d, 1);
          y2.$d[l2]($2), y2.init(), this.$d = y2.set(d, Math.min(this.$D, y2.daysInMonth())).$d;
        } else l2 && this.$d[l2]($2);
        return this.init(), this;
      }, m2.set = function(t2, e2) {
        return this.clone().$set(t2, e2);
      }, m2.get = function(t2) {
        return this[b.p(t2)]();
      }, m2.add = function(r2, f2) {
        var d2, l2 = this;
        r2 = Number(r2);
        var $2 = b.p(f2), y2 = function(t2) {
          var e2 = O(l2);
          return b.w(e2.date(e2.date() + Math.round(t2 * r2)), l2);
        };
        if ($2 === c) return this.set(c, this.$M + r2);
        if ($2 === h) return this.set(h, this.$y + r2);
        if ($2 === a) return y2(1);
        if ($2 === o) return y2(7);
        var M3 = (d2 = {}, d2[s] = e, d2[u] = n, d2[i] = t, d2)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return b.w(m3, this);
      }, m2.subtract = function(t2, e2) {
        return this.add(-1 * t2, e2);
      }, m2.format = function(t2) {
        var e2 = this, n2 = this.$locale();
        if (!this.isValid()) return n2.invalidDate || l;
        var r2 = t2 || "YYYY-MM-DDTHH:mm:ssZ", i2 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n2.weekdays, c2 = n2.months, f2 = n2.meridiem, h2 = function(t3, n3, i3, s3) {
          return t3 && (t3[n3] || t3(e2, r2)) || i3[n3].slice(0, s3);
        }, d2 = function(t3) {
          return b.s(s2 % 12 || 12, t3, "0");
        }, $2 = f2 || function(t3, e3, n3) {
          var r3 = t3 < 12 ? "AM" : "PM";
          return n3 ? r3.toLowerCase() : r3;
        };
        return r2.replace(y, function(t3, r3) {
          return r3 || function(t4) {
            switch (t4) {
              case "YY":
                return String(e2.$y).slice(-2);
              case "YYYY":
                return b.s(e2.$y, 4, "0");
              case "M":
                return a2 + 1;
              case "MM":
                return b.s(a2 + 1, 2, "0");
              case "MMM":
                return h2(n2.monthsShort, a2, c2, 3);
              case "MMMM":
                return h2(c2, a2);
              case "D":
                return e2.$D;
              case "DD":
                return b.s(e2.$D, 2, "0");
              case "d":
                return String(e2.$W);
              case "dd":
                return h2(n2.weekdaysMin, e2.$W, o2, 2);
              case "ddd":
                return h2(n2.weekdaysShort, e2.$W, o2, 3);
              case "dddd":
                return o2[e2.$W];
              case "H":
                return String(s2);
              case "HH":
                return b.s(s2, 2, "0");
              case "h":
                return d2(1);
              case "hh":
                return d2(2);
              case "a":
                return $2(s2, u2, true);
              case "A":
                return $2(s2, u2, false);
              case "m":
                return String(u2);
              case "mm":
                return b.s(u2, 2, "0");
              case "s":
                return String(e2.$s);
              case "ss":
                return b.s(e2.$s, 2, "0");
              case "SSS":
                return b.s(e2.$ms, 3, "0");
              case "Z":
                return i2;
            }
            return null;
          }(t3) || i2.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d2, l2) {
        var $2, y2 = this, M3 = b.p(d2), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
          return b.m(y2, m3);
        };
        switch (M3) {
          case h:
            $2 = D2() / 12;
            break;
          case c:
            $2 = D2();
            break;
          case f:
            $2 = D2() / 3;
            break;
          case o:
            $2 = (g2 - v2) / 6048e5;
            break;
          case a:
            $2 = (g2 - v2) / 864e5;
            break;
          case u:
            $2 = g2 / n;
            break;
          case s:
            $2 = g2 / e;
            break;
          case i:
            $2 = g2 / t;
            break;
          default:
            $2 = g2;
        }
        return l2 ? $2 : b.a($2);
      }, m2.daysInMonth = function() {
        return this.endOf(c).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t2, e2) {
        if (!t2) return this.$L;
        var n2 = this.clone(), r2 = w(t2, e2, true);
        return r2 && (n2.$L = r2), n2;
      }, m2.clone = function() {
        return b.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), k = _.prototype;
    return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function(t2) {
      k[t2[1]] = function(e2) {
        return this.$g(e2, t2[0], t2[1]);
      };
    }), O.extend = function(t2, e2) {
      return t2.$i || (t2(e2, _, O), t2.$i = true), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t2) {
      return O(1e3 * t2);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
export {
  AddSVG as A,
  ChatSVG as C,
  DownloadSVG as D,
  EditSVG as E,
  FileAction as F,
  HookSVG as H,
  LinkFileSVG as L,
  MoreIcon as M,
  NullFileSVG as N,
  PeopleSVG as P,
  RemoveSVG as R,
  SearchSVG as S,
  TableFileSVG as T,
  CopySVG as a,
  ReturnSVG as b,
  ClearWordSVG as c,
  dayjs as d,
  SmileSVG as e,
  CompareFileSVG as f,
  SendSVG as g,
  CloseSVG as h,
  DallmLogo as i,
  jsxRuntimeExports as j,
  HasFileSVG as k,
  EditAvatarSVG as l,
  CheckSVG as m
};
